import { Route, Routes } from "react-router-dom";
import React from "react";
import MyPage from "./MyPage";
import MyPageScoreDetail from "./MyPageScoreDetail";

export default function MyPageRouter() {
  return (
    <Routes>
      <Route path="" element={<MyPage />} />
      <Route path="score-detail" element={<MyPageScoreDetail />} />
    </Routes>
  );
}
